module.exports = __webpack_public_path__ + "static/media/Elephant Costume.805be8f0.jpg";